import { Button, Dropdown, P } from '@dnb/eufemia';
import { email as MailIcon } from '@dnb/eufemia/icons';
import { useNavigate } from 'react-router-dom';

import { ApiDetailedResponseEnvironmentRelease } from '@/openapi/schema';
import { DoNavigateProps } from '@/pages/api-documentation/ApiDocumentation';

import type { DropdownOption } from '../constants/types';

import { StyledButtonWrapper, StyledEnvironment, StyledHeaderControls } from '../styles/Api.styles';

export interface HeaderType {
  environments?: DropdownOption[];
  releases?: DropdownOption[];
  selectedVersion: string | null;
  selectedEnvironment: string | null;
  doNavigate: (props: DoNavigateProps) => void;
  latestMajorReleases?: ApiDetailedResponseEnvironmentRelease[];
  selected?: string | null;
  canSubscribe: boolean;
}

const HeaderControls = ({
  environments,
  selectedEnvironment,
  releases,
  selectedVersion,
  doNavigate,
  latestMajorReleases,
  selected,
  canSubscribe,
}: HeaderType) => {
  const navigate = useNavigate();

  const hasVersionedReleases = latestMajorReleases != null && latestMajorReleases.length > 0;

  return (
    <StyledHeaderControls>
      <StyledEnvironment>
        {environments && environments.length > 0 && (
          <Dropdown
            data={environments}
            label="Environment"
            label_direction="vertical"
            on_change={({ data }) => {
              doNavigate({ env: data.key });
            }}
            title="Select environment"
            value={environments.findIndex((option) => option.key === selectedEnvironment)}
          />
        )}

        {environments && environments.length > 0 && releases && releases.length > 0 && (
          <div className="flex flex-col gap-2">
            {hasVersionedReleases && <P>Version</P>}
            <div className="flex flex-wrap items-center gap-4">
              {hasVersionedReleases &&
                latestMajorReleases.map((release) => (
                  <Button
                    key={release.version}
                    on_click={() => doNavigate({ release: release.version })}
                    size="medium"
                    tooltip={`Version name: ${release.name}`}
                    variant={release.version === selectedVersion ? 'secondary' : 'tertiary'}
                  >
                    {release.version}
                  </Button>
                ))}
              <Dropdown
                data={releases}
                label={hasVersionedReleases ? undefined : 'Version'}
                label_direction="vertical"
                more_menu={hasVersionedReleases}
                on_change={({ data }) => {
                  doNavigate({ release: data.key });
                }}
                title="Select version"
                value={releases.findIndex((option) => option.key === selectedVersion)}
              />
            </div>
          </div>
        )}
      </StyledEnvironment>
      <StyledButtonWrapper>
        {canSubscribe && (
          <Button
            icon={MailIcon}
            icon_position="left"
            on_click={() => navigate(`/subscriptions/releases/${selected}`)}
            variant="secondary"
          >
            Subscribe
          </Button>
        )}
      </StyledButtonWrapper>
    </StyledHeaderControls>
  );
};

export default HeaderControls;
